module.exports = __webpack_public_path__ + "static/img/n.f311ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/n.png
// module id = ak4L
// module chunks = 1